import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

// Lightweight i18n: English + Malayalam for the mobile app screens.
// Extend the DICT as new UI strings appear. Missing keys fall back to English.

const DICT = {
  en: {
    // Home
    "home.shopsNearYou": "Shops near you",
    "home.subtitle": "Discover hyperlocal shops & offers around you",
    "home.searchPlaceholder": "Search shop or location",
    "home.all": "All",
    "home.within": "Within",
    "home.fromShopsYouLove": "From shops you love",
    "home.featuredForYou": "Featured for you",
    "home.recommendedNearby": "Recommended Nearby",
    "home.shopsCount": (n) => `${n} shops`,
    "home.noShops": "No shops in this range",
    "home.tryWider": "Try widening the radius or changing filters.",
    "home.km": "km",
    "home.locate": "Use my location",

    // Coupons
    "coupons.title": "My coupons",
    "coupons.none": "No coupons yet",
    "coupons.claimHint": "Claim offers from shops to see them here.",
    "coupons.redeemedOn": "Redeemed",
    "coupons.active": "Active",
    "coupons.off": "OFF",

    // Messages
    "messages.title": "Messages",
    "messages.subtitle": "Your conversations with shops",
    "messages.none": "No conversations",
    "messages.startHint": "Message a shop to start chatting.",
    "messages.you": "You:",
    "messages.shop": "Shop:",

    // Profile
    "profile.title": "Profile",
    "profile.language": "Language",
    "profile.english": "English",
    "profile.malayalam": "Malayalam",
    "profile.signOut": "Sign out",
    "profile.customer": "CUSTOMER",
    "profile.owner": "SHOP OWNER",
    "profile.admin": "ADMIN",
    "profile.approved": "APPROVED",
    "profile.pending": "PENDING",

    // Tabs
    "tab.home": "Home",
    "tab.map": "Map",
    "tab.coupons": "Coupons",
    "tab.messages": "Messages",
    "tab.profile": "Profile",

    // Menu drawer
    "menu.offers": "Offers",
    "menu.favorites": "Favorites",
    "menu.myCoupons": "My coupons",
    "menu.notifications": "Notifications",

    // Notifications page
    "notif.title": "Notifications",
    "notif.subtitle": "Latest updates from shops and admin",
    "notif.none": "You're all caught up",
    "notif.noneHint": "New offers and updates will appear here.",
    "notif.markAllRead": "Mark all read",
    "notif.allCaughtUp": "All caught up",
    "notif.unreadCount": (n) => `${n} unread`,

    // Offers
    "offers.hotOffers": "Hot Offers",
    "offers.within10": "Within 10 km of you",
    "offers.none": "No live offers nearby",
    "offers.checkBack": "Check back soon — shops post new deals daily.",
    "offers.badge": "OFFER",

    // Favorites
    "favorites.title": "Favorites",
    "favorites.none": "No favorites yet",
    "favorites.hint": "Tap the heart on a shop to save it here.",
  },
  ml: {
    "home.shopsNearYou": "അടുത്തുള്ള കടകൾ",
    "home.subtitle": "അടുത്തുള്ള ഹൈപ്പർലോക്കൽ കടകളും ഓഫറുകളും കണ്ടെത്തുക",
    "home.searchPlaceholder": "കട അല്ലെങ്കിൽ സ്ഥലം തിരയുക",
    "home.all": "എല്ലാം",
    "home.within": "പരിധിയിൽ",
    "home.fromShopsYouLove": "നിങ്ങൾ ഇഷ്ടപ്പെടുന്ന കടകളിൽ നിന്ന്",
    "home.featuredForYou": "നിങ്ങൾക്കായി ഫീച്ചർ ചെയ്തത്",
    "home.recommendedNearby": "അടുത്ത് ശുപാർശ ചെയ്യുന്നവ",
    "home.shopsCount": (n) => `${n} കടകൾ`,
    "home.noShops": "ഈ പരിധിയിൽ കടകൾ ഇല്ല",
    "home.tryWider": "പരിധി വർദ്ധിപ്പിക്കുകയോ ഫിൽട്ടറുകൾ മാറ്റുകയോ ചെയ്യുക.",
    "home.km": "കി.മീ.",
    "home.locate": "എന്റെ ലൊക്കേഷൻ ഉപയോഗിക്കുക",

    "coupons.title": "എന്റെ കൂപ്പണുകൾ",
    "coupons.none": "കൂപ്പണുകൾ ഒന്നുമില്ല",
    "coupons.claimHint": "കടകളിൽ നിന്ന് ഓഫറുകൾ എടുക്കുമ്പോൾ ഇവിടെ കാണാം.",
    "coupons.redeemedOn": "ഉപയോഗിച്ചത്",
    "coupons.active": "സജീവം",
    "coupons.off": "ഓഫ്",

    "messages.title": "സന്ദേശങ്ങൾ",
    "messages.subtitle": "കടകളുമായുള്ള നിങ്ങളുടെ സംഭാഷണങ്ങൾ",
    "messages.none": "സംഭാഷണങ്ങൾ ഇല്ല",
    "messages.startHint": "സംഭാഷണം തുടങ്ങാൻ ഒരു കടയ്ക്ക് സന്ദേശം അയക്കുക.",
    "messages.you": "നിങ്ങൾ:",
    "messages.shop": "കട:",

    "profile.title": "പ്രൊഫൈൽ",
    "profile.language": "ഭാഷ",
    "profile.english": "ഇംഗ്ലീഷ്",
    "profile.malayalam": "മലയാളം",
    "profile.signOut": "സൈൻ ഔട്ട്",
    "profile.customer": "ഉപഭോക്താവ്",
    "profile.owner": "കട ഉടമ",
    "profile.admin": "അഡ്മിൻ",
    "profile.approved": "അംഗീകൃതം",
    "profile.pending": "കാത്തിരിക്കുന്നു",

    "tab.home": "ഹോം",
    "tab.map": "മാപ്പ്",
    "tab.coupons": "കൂപ്പണുകൾ",
    "tab.messages": "സന്ദേശങ്ങൾ",
    "tab.profile": "പ്രൊഫൈൽ",

    "menu.offers": "ഓഫറുകൾ",
    "menu.favorites": "ഇഷ്ടപ്പെട്ടവ",
    "menu.myCoupons": "എന്റെ കൂപ്പണുകൾ",
    "menu.notifications": "അറിയിപ്പുകൾ",

    "notif.title": "അറിയിപ്പുകൾ",
    "notif.subtitle": "കടകളിൽ നിന്നും അഡ്മിനിൽ നിന്നും ഏറ്റവും പുതിയ അപ്ഡേറ്റുകൾ",
    "notif.none": "എല്ലാം അപ്ഡേറ്റാണ്",
    "notif.noneHint": "പുതിയ ഓഫറുകളും അപ്ഡേറ്റുകളും ഇവിടെ കാണാം.",
    "notif.markAllRead": "എല്ലാം വായിച്ചത് അടയാളപ്പെടുത്തുക",
    "notif.allCaughtUp": "എല്ലാം അപ്ഡേറ്റ്",
    "notif.unreadCount": (n) => `${n} വായിക്കാത്തവ`,

    "offers.hotOffers": "ഹോട്ട് ഓഫറുകൾ",
    "offers.within10": "നിങ്ങളിൽ നിന്ന് 10 കി.മീ. പരിധിയിൽ",
    "offers.none": "സമീപത്ത് ലൈവ് ഓഫറുകൾ ഇല്ല",
    "offers.checkBack": "ഉടനെ വീണ്ടും നോക്കുക — കടകൾ ദിവസവും പുതിയ ഓഫറുകൾ ചേർക്കുന്നു.",
    "offers.badge": "ഓഫർ",

    "favorites.title": "ഇഷ്ടപ്പെട്ടവ",
    "favorites.none": "ഇഷ്ടപ്പെട്ടവ ഒന്നുമില്ല",
    "favorites.hint": "ഒരു കടയിലെ ഹൃദയത്തിൽ ടാപ്പ് ചെയ്ത് ഇവിടെ സേവ് ചെയ്യാം.",
  },
};

const STORAGE_KEY = "nd_lang";
const I18nContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem(STORAGE_KEY) || "en";
  });

  const setLang = useCallback((next) => {
    setLangState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (_) {
      /* localStorage may be blocked */
    }
    if (typeof document !== "undefined") {
      document.documentElement.lang = next === "ml" ? "ml" : "en";
    }
  }, []);

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang === "ml" ? "ml" : "en";
    }
  }, [lang]);

  const t = useCallback(
    (key, ...args) => {
      const table = DICT[lang] || DICT.en;
      const val = table[key] ?? DICT.en[key] ?? key;
      return typeof val === "function" ? val(...args) : val;
    },
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>
  );
}

export function useT() {
  return useContext(I18nContext);
}
